export function getdata() {
	var obj = {
		headData: [{
				title: "行次",
				prop: "grade",
				custom: true,
				width: "100px",
				fixed:'left'
			}, {
				title: "项目",
				prop: 'title',
				width: "240px",
				custom: true,
				
				fixed:'left'
			},
			{
				title: '本年金额',
				children: [{
						title: '实收资本（或股本）',
						prop: 'cwbbyzx_3_x_1',
						width: "200px",
						custom: true,
						
					},
					{
						title: '其他权益工具',
						children: [{
								title: '优先股',
								prop: 'cwbbyzx_3_x_2',
								width: "200px",
								custom: true,
								
							},
							{
								title: '永续债',
								prop: 'cwbbyzx_3_x_3',
								width: "200px",
								custom: true,
								
							},
							{
								title: '其他',
								prop: 'cwbbyzx_3_x_4',
								width: "200px",
								custom: true,
								
							}
						]
					},
					{
						title: '资本公积',
						prop: 'cwbbyzx_3_x_5',
						width: "200px",
						custom: true,
						
					},
					{
						title: '减:库存股',
						prop: 'cwbbyzx_3_x_6',
						width: "200px",
						custom: true,
						
					},
					{
						title: '其他综合收益',
						prop: 'cwbbyzx_3_x_7',
						width: "200px",
						custom: true,
						
					},
					{
						title: '专项储备',
						prop: 'cwbbyzx_3_x_8',
						width: "200px",
						custom: true,
						
					},
					{
						title: '盈余公积',
						prop: 'cwbbyzx_3_x_9',
						width: "200px",
						custom: true,
						
					},
					{
						title: '未分配利润',
						prop: 'cwbbyzx_3_x_10',
						width: "200px",
						custom: true,
						
					},
					{
						title: '所有者权益合计',
						prop: 'cwbbyzx_3_x_11',
						width: "200px",
						custom: true,
						
					}
				]
			},
			{
				title: "上年金额",

				children: [{
						title: "实收资本（或股本）",
						prop: 'cwbbyzx_3_x_12',
						
						width: "200px",
						custom: true,
					},
					{
						title: "其他权益工具",
						children: [{
								title: "优先股",
								prop: 'cwbbyzx_3_x_13',
								
								width: "200px",
								custom: true,
							},
							{
								title: "永续债",
								prop: 'cwbbyzx_3_x_14',
								
								width: "200px",
								custom: true,
							},
							{
								title: "其他",
								prop: 'cwbbyzx_3_x_15',
								
								width: "200px",
								custom: true,
							},
						]
					},
					{
						title: "资本公积",
						prop: 'cwbbyzx_3_x_16',
						
						width: "200px",
						custom: true,
					},
					{
						title: "减:库存股",
						prop: 'cwbbyzx_3_x_17',
						
						width: "200px",
						custom: true,
					},
					{
						title: "其他综合收益",
						prop: 'cwbbyzx_3_x_18',
						
						width: "200px",
						custom: true,
					},
					{
						title: "专项储备",
						prop: 'cwbbyzx_3_x_19',
						
						width: "200px",
						custom: true,
					},
					{
						title: "盈余公积",
						prop: 'cwbbyzx_3_x_20',
						
						width: "200px",
						custom: true,
					},
					{
						title: "未分配利润",
						prop: 'cwbbyzx_3_x_21',
						
						width: "200px",
						custom: true,
					},
					{
						title: "所有者权益合计",
						prop: 'cwbbyzx_3_x_22',
						
						width: "200px",
						custom: true,
					},
				]

			}
		],
		tableData: [{
				title: "一、上年年末余额",
				grade: "1",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_1_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_1_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_1_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_1_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_1_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_1_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_1_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_1_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_1_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_1_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_1_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_1_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_1_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_1_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_1_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_1_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_1_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			},
			{
				title: "加：会计政策变更",
				grade: "2",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_2_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_2_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_2_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_2_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_2_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_2_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_2_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_2_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_2_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_2_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_2_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_2_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_2_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_2_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_2_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_2_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_2_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_2_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_2_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_2_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "前期差错更正",
				grade: "3",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_3_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_3_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_3_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_3_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_3_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_3_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_3_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_3_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_3_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_3_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_3_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_3_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_3_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_3_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_3_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_3_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_3_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_3_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_3_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_3_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "其他",
				grade: "4",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_4_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_4_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_4_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_4_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_4_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_4_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_4_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_4_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_4_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_4_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_4_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_4_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_4_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_4_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_1_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_4_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_4_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_4_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_4_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_4_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_4_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_4_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "二、本年年初余额",
				grade: "5",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_5_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_5_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_5_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_5_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_5_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_5_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_5_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_5_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_5_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_5_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_5_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_5_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_5_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_5_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_5_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_5_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_5_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_5_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_5_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_5_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_5_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_5_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "三、本年增减变动金额(减少以-号填)列)",
				grade: "6",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_6_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_6_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_6_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_6_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_6_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_6_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_6_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_6_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_6_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_6_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_6_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_6_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_6_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_6_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_6_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_6_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_6_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_6_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_6_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_6_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_6_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_6_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "(一)综合收益总额",
				grade: "7",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_7_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_7_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_7_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_7_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_7_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_7_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_7_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_7_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_7_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_7_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_7_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_7_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_7_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_7_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_7_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_7_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_7_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_7_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_7_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_7_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_7_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_7_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "(二)所有者投入和减少资本",
				grade: "8",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_8_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_8_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_8_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_8_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_8_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_8_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_8_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_8_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_8_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_8_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_8_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_8_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_8_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_8_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_8_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_8_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_8_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_8_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_8_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_8_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_8_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_8_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "1.所有者投入的普通股",
				grade: "9",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_9_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_9_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_9_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_9_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_9_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_9_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_9_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_9_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_9_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_9_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_9_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_9_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_9_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_9_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_9_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_9_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_9_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_9_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_9_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_9_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_9_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_9_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "2.其他权益工具持有者投入资本",
				grade: "10",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_10_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_10_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_10_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_10_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_10_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_10_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_10_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_10_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_10_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_10_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_10_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_10_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_10_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_10_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_10_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_10_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_10_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_10_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_10_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_10_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_10_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_10_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "3.股份支付计入所有者权益的金额",
				grade: "11",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_11_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_11_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_11_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_11_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_11_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_11_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_11_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_11_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_11_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_11_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_11_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_11_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_11_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_11_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_11_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_11_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_11_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_11_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_11_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_11_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_11_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_11_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "4.其他",
				grade: "12",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_12_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_12_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_12_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_12_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_12_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_12_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_12_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_12_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_12_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_12_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_12_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_12_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_12_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_12_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_12_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_12_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_12_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_12_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_12_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_12_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_12_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_12_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "(三)利润分配",
				grade: "13",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_13_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_13_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_13_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_13_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_13_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_13_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_13_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_13_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_13_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_13_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_13_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_13_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_13_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_13_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_13_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_13_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_13_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_13_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_13_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_13_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_13_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_13_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "1.提取盈余公积",
				grade: "14",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_14_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_14_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_14_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_14_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_14_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_14_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_14_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_14_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_14_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_14_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_14_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_14_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_14_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_14_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_14_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_14_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_14_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_14_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_14_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_14_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_14_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_14_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "2.对所有者(或股东)的分配",
				grade: "15",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_15_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_15_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_15_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_15_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_15_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_15_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_15_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_15_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_15_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_15_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_15_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_15_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_15_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_15_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_15_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_15_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_15_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_15_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_15_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_15_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_15_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_15_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "3.其他",
				grade: "16",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_16_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_16_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_16_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_16_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_16_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_16_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_16_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_16_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_16_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_16_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_16_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_16_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_16_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_16_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_16_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_16_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_16_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_16_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_16_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_16_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_16_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_16_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "(四)所有者权益内部结转",
				grade: "17",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_17_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_17_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_17_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_17_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_17_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_17_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_17_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_17_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_17_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_17_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_17_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_17_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_17_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_17_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_17_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_17_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_17_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_17_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_17_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_17_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_17_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_17_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "1.资本公积转增资本(或股本)",
				grade: "18",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_18_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_18_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_18_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_18_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_18_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_18_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_18_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_18_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_18_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_18_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_18_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_18_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_18_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_18_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_18_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_18_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_18_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_18_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_18_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_18_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_18_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_18_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "2.盈余公积转增资本(或股本",
				grade: "19",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_19_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_19_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_19_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_19_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_19_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_19_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_19_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_19_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_19_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_19_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_19_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_19_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_19_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_19_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_19_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_19_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_19_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_19_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_19_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_19_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_19_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_19_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "3.盈余公积弥补亏损",
				grade: "20",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_20_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_20_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_20_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_20_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_20_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_20_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_20_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_20_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_20_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_20_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_20_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_20_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_20_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_20_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_20_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_20_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_20_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_20_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_20_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_20_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_20_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_20_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "4.设定收益计划变动额结转留存收益",
				grade: "21",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_21_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_21_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_21_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_21_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_21_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_21_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_21_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_21_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_21_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_21_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_21_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_21_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_21_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_21_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_21_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_21_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_21_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_21_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_21_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_21_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_21_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_21_22",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				title: "5．其他综合收益结转留存收益",
				grade: "22",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_22_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_22_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_22_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_22_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_22_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_22_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_22_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_22_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_22_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_22_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_22_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_22_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_22_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_22_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_22_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_22_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_22_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_22_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_22_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_22_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_22_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_22_22",
					cellType: "1",
					cellVal: "240040043.08"
				},

			}, {
				title: "6.其他",
				grade: "23",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_23_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_23_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_23_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_23_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_23_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_23_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_23_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_23_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_23_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_23_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_23_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_23_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_23_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_23_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_23_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_23_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_23_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_23_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_23_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_23_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_23_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_23_22",
					cellType: "1",
					cellVal: "240040043.08"
				},

			}, {
				title: "四、本年年末余额",
				grade: "24",
				disabledcwbbyzx_3_x_1: false,
				disabledcwbbyzx_3_x_2: false,
				disabledcwbbyzx_3_x_3: false,
				disabledcwbbyzx_3_x_4: false,
				disabledcwbbyzx_3_x_5: false,
				disabledcwbbyzx_3_x_6: false,
				disabledcwbbyzx_3_x_7: false,
				disabledcwbbyzx_3_x_8: false,
				disabledcwbbyzx_3_x_9: false,
				disabledcwbbyzx_3_x_10: false,
				disabledcwbbyzx_3_x_11: false,
				disabledcwbbyzx_3_x_12: false,
				disabledcwbbyzx_3_x_13: false,
				disabledcwbbyzx_3_x_14: false,
				disabledcwbbyzx_3_x_15: false,
				disabledcwbbyzx_3_x_16: false,
				disabledcwbbyzx_3_x_17: false,
				disabledcwbbyzx_3_x_18: false,
				disabledcwbbyzx_3_x_19: false,
				disabledcwbbyzx_3_x_20: false,
				disabledcwbbyzx_3_x_21: false,
				disabledcwbbyzx_3_x_22: false,
				cwbbyzx_3_x_1: {
					cellCode: "cwbbyzx_3_24_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_2: {
					cellCode: "cwbbyzx_3_24_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_3: {
					cellCode: "cwbbyzx_3_24_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_4: {
					cellCode: "cwbbyzx_3_24_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_5: {
					cellCode: "cwbbyzx_3_24_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_6: {
					cellCode: "cwbbyzx_3_24_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_7: {
					cellCode: "cwbbyzx_3_24_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_8: {
					cellCode: "cwbbyzx_3_24_8",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_9: {
					cellCode: "cwbbyzx_3_24_9",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_10: {
					cellCode: "cwbbyzx_3_24_10",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_11: {
					cellCode: "cwbbyzx_3_24_11",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_12: {
					cellCode: "cwbbyzx_3_24_12",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_13: {
					cellCode: "cwbbyzx_3_24_13",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_14: {
					cellCode: "cwbbyzx_3_24_14",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_15: {
					cellCode: "cwbbyzx_3_24_15",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_16: {
					cellCode: "cwbbyzx_3_24_16",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_17: {
					cellCode: "cwbbyzx_3_24_17",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_18: {
					cellCode: "cwbbyzx_3_24_18",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_19: {
					cellCode: "cwbbyzx_3_24_19",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_20: {
					cellCode: "cwbbyzx_3_24_20",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_21: {
					cellCode: "cwbbyzx_3_24_21",
					cellType: "1",
					cellVal: "240040043.08"
				},
				cwbbyzx_3_x_22: {
					cellCode: "cwbbyzx_3_24_22",
					cellType: "1",
					cellVal: "240040043.08"
				},

			}
		]
	}
	return obj
}
